/**
 * Handles hex passthrough and rgb()/rgba(). When alpha < 1 the result is
 * 8-digit hex (`#RRGGBBAA`) so the alpha channel survives — both modern
 * browsers and our color picker accept this form (the picker truncates to
 * `#RRGGBB` for the native swatch). Returning `rgba(...)` would break the
 * picker, which slices `value.slice(0, 7)` → `"rgba(25"`.
 */
export function cssColorToHex(color: string | undefined): string | undefined {
  if (!color) return undefined;
  if (color.startsWith("#")) return color;
  const rgbMatch =
    /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:\s*,\s*([\d.]+))?\s*\)/.exec(color);
  if (rgbMatch) {
    const r = Number(rgbMatch[1]);
    const g = Number(rgbMatch[2]);
    const b = Number(rgbMatch[3]);
    const a = rgbMatch[4] !== undefined ? Number(rgbMatch[4]) : 1;
    const rgb = `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
    if (Number.isFinite(a) && a < 1) {
      const alphaByte = Math.round(Math.max(0, Math.min(1, a)) * 255);
      return `${rgb}${alphaByte.toString(16).padStart(2, "0")}`;
    }
    return rgb;
  }
  return color;
}
